import { useEffect, useState } from "react";
import Search from "../components/Dashboard/Search.js";
import config from "../constants/config.js";
import MigrationsTable from "../components/Dashboard/MigrationsTable.js";
import { useToast } from "../context/ToastProvider.js";
import MigrationWidget from "../components/Dashboard/MigrationWidget.js";

function Migrations() {
    const [ migrations , setMigrations ] = useState( [] );
    const [ shops , setShops ] = useState( [] );
    const [ loadingTable , setLoadingTable ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ totalPages, setTotalPages ] = useState( 1 );
    const [ reloadTable , setReloadTable ] = useState( 0 );
    const [ reloadId , setReloadId ] = useState( -1 );
    const [ toggleMigrationWidget , setMigrationWidget ] = useState( false );

    const addToast = useToast();

    useEffect( () => {
        async function load() {
            setLoadingTable( true );

            /**
             * Load Shoplist
             */
            const _shops = await getShopList();
            if ( _shops.length > 0 ) {
                setShops( _shops );
            }
 
            /**
             * Load Migrations. 
             */
            const _migrations = await getMigrations( currentPage );
            if ( _migrations != null ) {
                setTotalPages( _migrations?.pagination?.total_pages || 0 );
                setMigrations( _migrations?.migrations || [] );
            }

            setLoadingTable( false );
        }

        load();
    } , [ currentPage , reloadTable ] );

    useEffect( () => {
        async function load() {
            const migration = await getMigrationById( reloadId );
            if ( migration ) {
                const updatedMigrationList = [];

                for ( let i = 0; i < migrations.length; i++ ) {
                    if ( migrations[i].id == reloadId ) {
                        updatedMigrationList.push( migration );
                    } else {
                        updatedMigrationList.push( migrations[i] );
                    }
                }

                setMigrations( updatedMigrationList );
                addToast( `Finished Migration Refresh for ${reloadId}`, false , 1000 );
            }
        }

        if ( reloadId != -1 ) {
            load();
            setReloadId( -1 );
        }
    } , [ reloadId ] )

    function toggleMigrationModal() {
        setMigrationWidget( !toggleMigrationWidget );
    }

    function reloadAllMigrationsInView( event ) {
        setReloadTable( reloadTable + 1 );
    }

    async function getMigrations( page ) {
        let migrationData = null;

        try {
            const MIGRATIONS_PER_PAGE = 25;
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/migrations?page=${encodeURIComponent( page )}&limit=${encodeURIComponent( MIGRATIONS_PER_PAGE )}`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            
            const response = await fetch( url , requestSettings );
            const data = await response.json();

            if ( data?.migrations?.length > 0 ) {
                migrationData = data;
            }
        } catch ( error ) {
            console.log( error );
        }

        return migrationData;
    }

    async function getMigrationById( id ) {
        let migrationData = null;

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/migrations/${encodeURIComponent( id )}`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            
            const response = await fetch( url , requestSettings );
            const data = await response.json();

            if ( data != null ) {
                migrationData = data;
            }
        } catch ( error ) {
            console.log( error );
        }

        return migrationData;
    }

    async function getShopList() {
        let shops = [];

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/shops`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            const response = await fetch( url , requestSettings );
            const data = await response.json();

            if ( data?.shopList != null && data?.shopList?.length > 0 ) {
                shops = data.shopList;

            }
        } catch ( error ) {
            console.log( error );
        }

        return shops;
    }

    async function setMigrationStatus( id , status ) {
        let migrationToUpdate = null;
        for ( let i = 0; i < migrations.length; i++ ) {
            if ( migrations[i].id == id ) {
                migrationToUpdate = migrations[i];
                break;
            }
        }

        if ( migrationToUpdate != null ) {
            const currentErrors = migrationToUpdate.reported_errors ?? [];
            const error = {
                message: "Migration was manually aborted from dashboard after being stuck in an incomplete status for too long.",
                runtimeErrorReported: []
            };

            currentErrors.push( error )

            try {
                const payload = {
                    status: status,
                    errors: currentErrors,
                    progress: 100
                };

                const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/migrations/${encodeURIComponent( id )}/status`;
                const requestSettings = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify( payload )
                };
                const response = await fetch( url , requestSettings );
                setReloadId( id );
            } catch ( error ) {
                console.log( error );
                addToast( `Failed to update the status of migration id ${id}.` , true , 1000 );
            }
        }
        
        return;
    }

    function onMigrationStarted( success ) {
        setTimeout( () => {
            if ( success ) {
                addToast( `Created a new migration!` , false , 2000 );
            } else {
                addToast( `Failed to create a new migration! An error occured.` , false , 10000 );
            }
        
            toggleMigrationModal();
            setReloadTable( reloadTable + 1 );
        } , 2000 );

        return;
    }

    return(
        <div className="dashboard-wrapper">
            <div className="dashboard-header">
                <div className="actions-row">
                    <div className="actions-group">
                        <button className="action-btn" onClick={ toggleMigrationModal }>
                            <span className="icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 0.53125C7.5 0.239062 7.25893 0 6.96429 0C6.66964 0 6.42857 0.239062 6.42857 0.53125V6.375H0.535714C0.241071 6.375 0 6.61406 0 6.90625C0 7.19844 0.241071 7.4375 0.535714 7.4375H6.42857V13.2812C6.42857 13.5734 6.66964 13.8125 6.96429 13.8125C7.25893 13.8125 7.5 13.5734 7.5 13.2812V7.4375H13.3929C13.6875 7.4375 13.9286 7.19844 13.9286 6.90625C13.9286 6.61406 13.6875 6.375 13.3929 6.375H7.5V0.53125Z" fill="white"/>
                                </svg>
                            </span>
                            <span className="title">Start Migration</span>
                        </button>

                        <button disabled={loadingTable} className='action-btn' onClick={ reloadAllMigrationsInView }>
                            { loadingTable ?
                                <span className="icon">
                                    <svg width="15" height="15" viewBox="0 0 50 50" className="spinner">
                                        <circle cx="25" cy="25" r="20" stroke="white" strokeWidth="5" fill="none" strokeDasharray="90 150" strokeLinecap="round">
                                            <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                                        </circle>
                                    </svg>
                                </span>
                            :
                                <span className="icon">
                                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.1953 8.52115C12.529 11.0553 10.2321 12.9231 7.5 12.9231C5.79241 12.9231 4.25558 12.1928 3.1808 11.0284L4.55357 9.64856C4.72433 9.47692 4.82143 9.24135 4.82143 8.99904C4.82143 8.49086 4.41295 8.08029 3.90737 8.08029L0.535714 8.07692C0.241071 8.07692 0 8.31923 0 8.61538V12.0043C0 12.5125 0.408482 12.9231 0.914062 12.9231C1.15513 12.9231 1.38951 12.8255 1.56027 12.6538L2.42076 11.7889C3.69308 13.1486 5.49777 14 7.5 14C10.7612 14 13.5 11.7452 14.2567 8.70288C14.3371 8.37644 14.0826 8.07692 13.7478 8.07692C13.4866 8.07692 13.2623 8.26538 13.1953 8.52115ZM11.8192 2.97163L10.4464 4.35144C10.2757 4.52308 10.1786 4.75865 10.1786 5.00096C10.1786 5.50913 10.5871 5.91971 11.0926 5.91971L14.4643 5.92308C14.7589 5.92308 15 5.68077 15 5.38462V1.99567C15 1.4875 14.5915 1.07692 14.0859 1.07692C13.8449 1.07692 13.6105 1.17452 13.4397 1.34615L12.5792 2.21106C11.3069 0.851442 9.50223 0 7.5 0C4.23884 0 1.5 2.25481 0.743304 5.29711C0.662946 5.62356 0.917411 5.92308 1.25223 5.92308C1.51339 5.92308 1.73772 5.73462 1.80469 5.47885C2.47098 2.94471 4.76786 1.07692 7.5 1.07692C9.20759 1.07692 10.7444 1.80721 11.8225 2.97163H11.8192ZM13.9286 4.84615H11.471L13.9286 2.37596V4.84615ZM1.07143 9.15385H3.52902L1.07143 11.624V9.15385Z" fill="white"></path></svg>
                                </span>
                            }
                            <span className="title">Refresh</span>
                            
                        </button>
                    </div>
                    <div className="actions-group">
                        <Search />
                    </div>
                </div>
            </div>
            <div className="dashboard-body">
                <h1 className="dashboard-title">Migrations</h1>
                <MigrationsTable
                    migrations={ migrations } 
                    shops={ shops }
                    loading={ loadingTable } 
                    pagination={{
                        currentPage: currentPage,
                        totalPages: totalPages
                    }}
                    goToPreviousPage={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    goToNextPage={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    onUpdate={() => setReloadTable( reloadTable + 1 ) }
                    onRefreshMigration={ (id) => { setReloadId( id ) } }
                    onSetStatus={ setMigrationStatus }
                />

                { toggleMigrationWidget &&
                    <MigrationWidget 
                        shops={shops}
                        onCancel={ toggleMigrationModal }
                        onClose={ toggleMigrationModal }
                        onStartMigration={onMigrationStarted}
                    />
                }
            </div>
        </div>
    );
}

export default Migrations;